import request from "@/utils/request";

export function cjywList(params) {
  return request({
    url: "/system/cjyw/cjywList",
    method: "post",
    data: params,
  });
}
// 批量处理数据装填
export function lotSizedealWith(params) {
  return request({
    url: "/system/cjyw/lotSizedealWith",
    method: "post",
    data: params,
  });
}

// 获取数据详情
export function dataDetails(params) {
  const { id } = params;
  return request({
    url: `/system/cjyw/dataDetails/${id}`,
    method: "get",
  });
}

// 业务数据统计获取列表
export function cjywStatistics(params) {
  return request({
    url: "/system/cjyw/cjywStatistics",
    method: "post",
    data: params,
  });
}

// 业务分组统计获取列表
export function cjywfzStatistics(params) {
  return request({
    url: "/system/cjyw/cjywfzStatistics",
    method: "post",
    data: params,
  });
}

// 业务数据统计获取列表
export function minutePacket(params) {
  return request({
    url: "/system/cjyw/minutePacket",
    method: "post",
    data: params,
  });
}

// 数据同步管理列表
export function dataSynchronizationList(params) {
  return request({
    url: "/system/cjyw/dataSynchronizationList",
    method: "post",
    data: params,
  });
}

// 数据同步管理列表
export function processingAnnualList() {
  return request({
    url: "/system/cjyw/processingAnnualList",
    method: "get",
  });
}

// 数据归档
export function collectDataArchive(params) {
  return request({
    url: "/system/cjyw/collectDataArchive",
    method: "post",
    data: params,
  });
}